import React, { useEffect, useState } from "react";
import Alert from "components/common/Alert";
import ConfirmDialog from "components/common/ConfirmDialog";
import { MAX_ACTIVATION_HOURS, startActivation } from "features/access/services/activationService";

const HOUR_OPTIONS = Array.from({ length: MAX_ACTIVATION_HOURS }, (_, i) => i + 1);

function messageOf(e) {
  const msg = e?.responseBody?.error?.message;
  return typeof msg === "string" && msg.trim() ? msg : e?.message || "Activeren is niet gelukt.";
}

// Issue #23 (rechten F2): een eigen activeerbare rol (bv. Beheer) aanzetten: hoe lang (1..8 uur) en waarom (verplicht,
// komt in de historiek). role = { idAssignment, name }. Na succes onActivated(activatie) — de oproeper herlaadt auth/me.
export default function ActivationDialog({ open, role, tokenProvider, onActivated, onCancel }) {
  const [hours, setHours] = useState(1);
  const [reason, setReason] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      setHours(1);
      setReason("");
      setError(null);
    }
  }, [open, role?.idAssignment]);

  const confirm = async () => {
    setError(null);
    try {
      const res = await startActivation(tokenProvider, { idAssignment: role.idAssignment, hours, reason });
      onActivated?.(res);
    } catch (e) {
      setError(messageOf(e));
    }
  };

  return (
    <ConfirmDialog
      open={open}
      title={`${role?.name || "Rol"} activeren`}
      confirmLabel="Activeren"
      onConfirm={confirm}
      onCancel={onCancel}
    >
      {error ? (
        <Alert type="error" title="Niet geactiveerd">
          {error}
        </Alert>
      ) : null}
      <p className="confirm-dialog__message">
        De rol telt pas mee zolang hij geactiveerd is, hoogstens {MAX_ACTIVATION_HOURS} uur. Je kan hem altijd vroeger
        beëindigen. Mogelijk vraagt de app een extra bevestiging van je aanmelding.
      </p>
      <label className="ac-field__label" htmlFor="ac-activate-hours">
        Hoe lang
      </label>
      <select id="ac-activate-hours" className="input" value={hours} onChange={(e) => setHours(Number(e.target.value))}>
        {HOUR_OPTIONS.map((h) => (
          <option key={h} value={h}>
            {h} uur
          </option>
        ))}
      </select>
      <label className="ac-field__label" htmlFor="ac-activate-reason">
        Reden (optioneel)
      </label>
      <textarea
        id="ac-activate-reason"
        className="input"
        rows={2}
        maxLength={400}
        placeholder="optioneel"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
      />
    </ConfirmDialog>
  );
}
